import { render, staticRenderFns } from "./learnDetail.vue?vue&type=template&id=56daa05e&scoped=true"
import script from "./learnDetail.vue?vue&type=script&lang=js"
export * from "./learnDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/learnDetail.scss?vue&type=style&index=0&id=56daa05e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56daa05e",
  null
  
)

export default component.exports